import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledCreateAndEnrollStudentStep = styled.div`
  .bigger-text {
    margin-top: 10px;
    font-size: 108%;
    width: 100%;
    font-weight: bold;
  }
`;
